import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { Loader2, FileText } from "lucide-react";

// Reiner PDF-Viewer (keine Gliederung / kein Editor). Optionaler `actions`-Slot
// rechts im Kopf für einzelne Aktionen (z.B. QK „Zurücksetzen").
export default function PdfViewer({ docId, actions }) {
  const [doc, setDoc] = useState(null);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setDoc(null);
    api.get(`/documents/${docId}`).then((r) => active && setDoc(r.data)).catch(() => {});
    return () => { active = false; };
  }, [docId]);

  useEffect(() => {
    let urls = []; let cancelled = false;
    setPages([]); setLoading(true);
    (async () => {
      try {
        const info = await api.get(`/documents/${docId}/pages`);
        const count = Math.min(info.data.page_count || 0, 40);
        for (let i = 0; i < count; i++) {
          if (cancelled) break;
          const r = await api.get(`/documents/${docId}/page/${i}.png`, { responseType: "blob" });
          const u = URL.createObjectURL(r.data);
          urls.push(u);
          setPages((p) => [...p, u]);
        }
      } catch { /* ignore */ }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; urls.forEach((u) => URL.revokeObjectURL(u)); };
  }, [docId]);

  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="shrink-0 flex items-center justify-between gap-3 px-5 h-14 border-b border-gray-200 bg-white">
        <div className="flex items-center gap-2 min-w-0">
          <FileText className="h-4 w-4 text-[#0F4C81] shrink-0" />
          <span className="font-mono text-sm text-gray-800 truncate" data-testid="viewer-filename">{doc?.filename || "…"}</span>
          {doc && <StatusBadge status={doc.status} testId="viewer-status" />}
        </div>
        {actions ? <div className="shrink-0 flex items-center gap-2">{actions}</div> : null}
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto bg-gray-100 p-5">
        <div className="max-w-3xl mx-auto space-y-4">
          {pages.length > 0 ? pages.map((src, i) => (
            <img key={i} src={src} alt={`Seite ${i + 1}`} data-testid={`viewer-page-${i}`} className="w-full shadow-sm border border-gray-200 bg-white" />
          )) : (
            <div className="py-24 flex flex-col items-center text-gray-400">
              {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : <><FileText className="h-8 w-8" /><p className="mt-2 text-sm">Keine Seiten verfügbar.</p></>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
